import { render, staticRenderFns } from "./products.vue?vue&type=template&id=eb4b06f6&scoped=true"
import script from "./products.vue?vue&type=script&lang=js"
export * from "./products.vue?vue&type=script&lang=js"
import style0 from "./products.vue?vue&type=style&index=0&id=eb4b06f6&prod&lang=scss&scoped=true"
import style1 from "./products.vue?vue&type=style&index=1&id=eb4b06f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4b06f6",
  null
  
)

export default component.exports